import React, { ComponentType } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '@material-ui/core/styles/withTheme';
import BaseListSlick, { styles } from '../../front/Shared/ListSlick';
import Card from '../../front/Plans/Card';
import { Props as BaseProps } from '../../core/Shared/ListSlick';
import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';

type Props = {
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  isAuthenticated: boolean;
  defaultIsVisible: boolean;
  /** 参加リクエスト受付中バッジを表示するか（TOP 新着おてつたび欄のみ true） */
  showRequestBadge?: boolean;
};

class ListSlick extends BaseListSlick {
  props: BaseProps & Props;

  slickItemsRenderer() {
    const {
      classes,
      plans = [],
      isAuthenticated,
      defaultIsVisible,
      showRequestBadge,
    } = this.props;
    return plans.map((plan, index) => (
      <Card
        key={`plan-list-slick${index}`}
        isAuthenticated={isAuthenticated}
        defaultIsVisible={defaultIsVisible}
        fixTermTextLine
        elevation={1}
        className={classes.card}
        showRequestBadge={showRequestBadge}
        {...plan}
      />
    ));
  }
}

export default withTheme(withStyles(styles)(ListSlick)) as ComponentType<Props>;
